import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

const FAQS = [
  {
    q: 'What happens when I run out of credits?',
    a: 'Metered actions pause until you top up or move to a larger plan. Nothing is billed automatically on top of your subscription, and reviews of public arXiv papers keep working for free.',
  },
  {
    q: 'Do my credits expire?',
    a: 'On a paid plan, credits you do not use carry into the next month — once. Anything still unused at the end of that second month expires. On the free plan there is no carry-over: the balance resets every month. Credits bought as a top-up never expire. Carried credits are always spent first, so nothing lapses while newer credits sit unused.',
  },
  {
    q: 'Can I cancel or downgrade?',
    a: 'Any time, from your account settings. Your plan stays active until the end of the period you already paid for. Plan credits and carried credits end with that period; top-up credits stay in your balance. Unused credits are not paid out in cash, and your statutory right of withdrawal is untouched.',
  },
  {
    q: 'Does the free plan mark my PDF?',
    a: 'Yes, and we say so up front: PDFs compiled on the free plan carry a small “Made with PaperVerse | paperverse.io” credit line in the footer of every page. It is deliberately unobtrusive and does not touch your text. Any paid plan compiles without it, and also unlocks the LaTeX source export. If you upgrade, recompiling the draft removes the line at no credit cost.',
  },
  {
    q: 'Where is my draft processed?',
    a: 'In the EU/EEA. Your manuscripts are processed on EU infrastructure and private drafts stay private — they are never published or used to train models.',
  },
];

export const PricingFaq = () => {
  return (
    <section aria-labelledby="pricing-faq-heading" className="max-w-3xl mx-auto w-full">
      <h2 id="pricing-faq-heading" className="text-xl font-semibold text-center mb-4">
        Questions
      </h2>
      <Accordion type="single" collapsible className="w-full">
        {FAQS.map((item, index) => (
          <AccordionItem key={item.q} value={`faq-${index}`}>
            <AccordionTrigger className="text-left text-sm">{item.q}</AccordionTrigger>
            <AccordionContent className="text-sm text-muted-foreground">
              {item.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
};

export default PricingFaq;
